// extracted by mini-css-extract-plugin
export default {"item":"slider_item__Ir+y3","fg":"slider_fg__sVfBM","av":"slider_av__Fbec4","container":"slider_container__oZcpn","counterDisplay":"slider_counterDisplay__Gx2Ru"};